import HeaderComponent from './HeaderComponent.vue'

export default HeaderComponent



// WEBPACK FOOTER //
// ./client/masteradmin/components/HeaderComponent/index.js